const translations = {
  title: 'Templates',
  titleDetails: 'Detalhes',
  titleEdit: 'Editar Templates',
  insertedAt: 'Criado em: ',
  updatedAt: 'Atualizado em: ',
  entity: 'Entidade',
  document: 'Documento',
  description: 'Descrição',
  docsGenerate: 'Documentos gerados',
  docsHistory: 'Histórico de Documentos',
  addNew: 'Adicionar Novo Template',
  'input.addDocument': 'Adicionar Documento',
  'input.isDisabled': 'Desabilitar Template',
  name: 'Nome',
  modalTitle: 'Criando template',
  modalTitle_edit: 'Editando template',
  listTitle: 'Templates de documentos',
  addNewButton: 'Add Novo',
  exclusiveForChecklist: 'Exclusivo para o checklist (opcional)',
  exclusiveForPlaceType: 'Exclusivo para o tipo de destino (opcional)',
  type: 'Tipo'
}

export default translations
